import Responses from './components/Responses';
export default Responses;